export default {"src":"/_next/static/media/odds-op.1f47d767.gif","height":360,"width":360,"blurWidth":0,"blurHeight":0};